<h2 class="covid" *ngIf="participant.covid">Impstatus: {{participant.covid.stateStr}}</h2>
<div *ngIf="participant.covid.state=='VACCINATED_3RD'" class="detail">3. Imfpung am {{participant.covid.date | amDateFormat:'D.M.YYYY'}}</div>
<div *ngIf="participant.covid.state=='VACCINATED_2ND'" class="detail">2. Imfpung am {{participant.covid.date | amDateFormat:'D.M.YYYY'}}</div>
<div *ngIf="participant.covid.state=='RECOVERED'" class="detail">genesen am {{participant.covid.date | amDateFormat:'D.M.YYYY'}}</div>
<!--<div class="actions">-->
<!--  <button mat-stroked-button (click)="absence()">Abwesend</button>-->
<!--  <button mat-stroked-button (click)="presence()">Anwesend</button>-->
<!--</div>-->

